/**
 * Distribute a number(value) x(count) times.
 * To avoid fractions, the remainder is added one at a time to each distributed value.
 *
 * Useful for column widths to avoid fractions where the browser will then decide how to round.
 *
 * E.g. distributeValue(100, 3) => [34, 33, 33]
 *
 * A table is made up of 3 columns with a total width of 100px. First column is 34px, second two are 33px.
 */
export const distributeValue = (value: number, count: number) => {
  const result: number[] = new Array(count).fill(Math.floor(value / count))
  let remaining = value % count
  for (let i = 0; i < count; i++) {
    if (remaining > 0) {
      result[i] += 1
      remaining--
    }
  }
  return result
}
